<template>
    <div v-if="buyTicketModal" class="buy-ticket-modal d-flex justify-content-center" @click.self="closeBuyTicketModal">
        <div v-if="buyTicketSide" class="inside-modal d-flex flex-column">
            <div class="d-flex flex-row justify-content-center buy-ticket-header">
                <span>BUY TICKET</span>
                <button class="close-button" @click="closeBuyTicketModal">x</button>
            </div>
            <div class="d-flex flex-row justify-content-between px-5 py-3">
                <div class="buy-ticket-info">
                    buy:
                </div>
                <div class="buy-ticket-info">
                    <img src="../assets/images/buy-ticket-ticket.webp" alt=""> ticket
                </div>
            </div>
            <div class="d-flex flex-row justify-content-center px-5">
                <div class="calculate-background windows-command-prompt">
                    <p>
                        <input class="total-ticket px-1" oninput="this.value=this.value.replace(/[^0-9]/g,'');" v-model="ticketCount">
                    </p>
                    <p class="total-price px-1">-{{ totalAmount }} #EGGS</p>
                </div>
            </div>
            <div class="d-flex flex-row justify-content-center px-5">
                <div class="egg-balance windows-command-prompt">
                    <p>
                        $EGGS Balance: {{ parseFloat(eggsBalance).toFixed(2) }}
                    </p>
                </div>
            </div>
            <div class="d-flex flex-row justify-content-center px-5">
                <button @click="calculateMaxTicketsToBuy" class="max-button">
                    Max
                </button>
            </div>
            <div class="d-flex flex-row justify-content-center mt-5 px-5 pb-2" >
                <div style="width:100%;height:3px; background: #384e99">
                    
                </div>

            </div>
            <div class="d-flex flex-row justify-content-between cost-info px-5 windows-command-prompt">
                <div>You pay {{ totalAmount }} $EGGS</div>
            </div>
            <div class="d-flex flex-row justify-content-center px-5">
                <button @click="instantPurchase" class="buy-instantly-button">
                    Buy instantly
                </button>
            </div>
            <div class="d-flex flex-row justify-content-center px-5">
                <button class="view-edit-button" @click="goViewEdit()">
                    view/edit numbers -&gt;
                </button>
            </div>
        </div>
        <div v-else class="inside-modal d-flex flex-column">
            <div class="d-flex flex-row justify-content-center buy-ticket-header">
                <span>Edit Ticket</span>
                <button class="close-button" @click="closeBuyTicketModal">x</button>
            </div>
            <div class="d-flex flex-row justify-content-between px-5 py-3 windows-command-prompt">
                <div class="ticket-cost-info">
                    Total cost: 
                </div>
                <div class="ticket-cost-info">
                     -0,32 $EGGS
                </div>
            </div>
            <div class="d-flex flex-row justify-content-center">
                <button class="randomize-button" @click="getRandomNumbers">
                    randomize
                </button>
            </div>
            <div class="ticket-informations">
                <div v-for="(ticket,idx) in choosenNumbers" :key="idx"  style="direction : ltr">
                    <div class="d-flex flex-row justify-content-start mt-md-4 mx-md-4 mx-3 mt-2 windows-command-prompt fs-3 text-white">
                    #{{(idx + 1).toLocaleString('en-US', {minimumIntegerDigits: 3, useGrouping:false})}}
                    </div>
                    <div class="d-flex flex-row justify-content-md-start justify-content-center mx-md-5 mx-4" >
                        <div class="winner-numbers">
                            <img src="../assets/images/winning-eggs.webp" alt="">
                            <div class="numbers-positioning">
                              <!-- <span
                                class="d-md-none d-flex"
                                v-for="(number , secondIdx) in choosenNumbers[idx]"
                                :class="'_'+secondIdx+ '-winning-number'"
                                :key="secondIdx + 'key' + idx"
                                 >{{choosenNumbers[idx][secondIdx]}}</span>  -->
                                <input 
                                class="d-md-flex"
                                v-for="(number , secondIdx) in choosenNumbers[idx]"
                                :class="'_'+secondIdx+ '-winning-number'"
                                :id="idx + '' + secondIdx" 
                                oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                                @keyup="autoTab(idx + '' + secondIdx, 1 , idx + '' + (secondIdx+1) , idx , secondIdx)" 
                                @click="selectField(idx + '' + secondIdx)" 
                                type="text"
                                :key="secondIdx + 'key'" 
                                :value="number">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            
            <div class="button-side-for-edit-numbers">
                <div class="d-flex flex-row justify-content-center px-5">
                    <button @click="purchase" class="confirm-and-purchase-button windows-command-prompt">
                        Confirm and Purchase
                    </button>
                </div>
                <div class="d-flex flex-row justify-content-center px-5">
                    <button class="return-button windows-command-prompt" @click="buyTicketSide = true">
                            &lt;- Return
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'buy-ticket',
    props: {
        buyTicketModal:{
            default: false,
            type: Boolean
        },
        eggsBalance: {
            default: "0.00",
            type: String
        },
        roundNumber: null,
        eggsInstance: null,
        lottery: null
    },
    data(){
        return{
            ticketCount:1,
            totalAmount: 5,
            buyTicketSide: true,
            choosenNumbers : [],
        }
    },
    methods: {
        autoTab(field1, len, field2 , idx , changedNumber) {
            let haveToChange = this.choosenNumbers[idx]
                if(changedNumber == 0){
                    this.choosenNumbers[idx] = this.choosenNumbers[idx] - haveToChange[changedNumber] * 100000
                    this.choosenNumbers[idx] = (this.choosenNumbers[idx] + document.getElementById(field1).value * 100000).toString()
                }
                if(changedNumber == 1){
                    this.choosenNumbers[idx] = this.choosenNumbers[idx] - haveToChange[changedNumber] * 10000
                    this.choosenNumbers[idx] = (this.choosenNumbers[idx] + document.getElementById(field1).value * 10000).toString()
                }
                if(changedNumber == 2){
                    this.choosenNumbers[idx] = this.choosenNumbers[idx] - haveToChange[changedNumber] * 1000
                    this.choosenNumbers[idx] = (this.choosenNumbers[idx] + document.getElementById(field1).value * 1000).toString()
                }
                if(changedNumber == 3){
                    this.choosenNumbers[idx] = this.choosenNumbers[idx] - haveToChange[changedNumber] * 100
                    this.choosenNumbers[idx] = (this.choosenNumbers[idx] + document.getElementById(field1).value * 100).toString()
                }
                if(changedNumber == 4){
                    this.choosenNumbers[idx] = this.choosenNumbers[idx] - haveToChange[changedNumber] * 10
                    this.choosenNumbers[idx] = (this.choosenNumbers[idx] + document.getElementById(field1).value * 10).toString()
                }
                if(changedNumber == 5){
                    this.choosenNumbers[idx] = this.choosenNumbers[idx] - haveToChange[changedNumber] * 1
                    this.choosenNumbers[idx] = (this.choosenNumbers[idx] + document.getElementById(field1).value * 1).toString()
                }
            if (document.getElementById(field1).value.length == len && field1 !== idx+'5') {
                document.getElementById(field2).focus();
                this.selectField(field2);
            }else if(field1 == idx+'5'){
                document.getElementById(field1).blur()
            }
        },
        async purchase(){
            let price = await this.lottery.costToBuyTickets(
                this.roundNumber,
                this.ticketCount
            );
            // console.log([price.toString(), price])
            let approveRequest = await (await this.eggsInstance.approve(this.lottery.address, price)).wait()
            console.log(approveRequest)
            // await this.eggsInstance.provider.waitForTransaction(approveRequest.hash, 3, 150000)
            // console.log("now we are done")
            // console.log("Eggs ready now get tickets")
            this.batchBuyTicket()
            // this.checkTransactionConfirmed(result, this.batchBuyTicket)
        },
        async batchBuyTicket(){
            let flattened_numbers = Array.prototype.concat.apply(
                [], this.choosenNumbers.map((n) => {return n.split("")}))
            await this.lottery.batchBuyLottoTicket(
                    this.roundNumber,
                    this.ticketCount,
                    flattened_numbers
                );
        },
        closeBuyTicketModal(){
            this.buyTicketSide = true
            this.$emit('closeBuyTicketModal')
        },
        instantPurchase(){
            this.generateTickets()
            // let flattened_numbers = Array.prototype.concat.apply([], this.choosenNumbers.map((n) => {return n.split("")}))
            // console.log(flattened_numbers)
            this.purchase()
        },
        goViewEdit(){
            this.generateTickets()
            this.buyTicketSide = false
        },
        generateTickets(){
            this.choosenNumbers = []
            for(let idx=0 ; idx<this.ticketCount ; idx++){
                let randomNumber = Math.floor(100000 + Math.random() * 900000);
                this.choosenNumbers.push(randomNumber.toString())
            }
        },
        selectField(fieldId){
            document.getElementById(fieldId).select();
        },
        getRandomNumbers(){
            this.choosenNumbers = []
            for(let idx=0 ; idx<this.ticketCount ; idx++){
                    let randomNumber = Math.floor(100000 + Math.random() * 900000);
                    this.choosenNumbers.push(randomNumber.toString())
                }
        },
        calculateMaxTicketsToBuy(){
            let max = Math.floor(this.eggsBalance / 5)
            console.log(max)
            this.ticketCount = max
        }
    },
    watch: {
        ticketCount: function (val) {
            this.totalAmount = 5 * val
        }
    }
}
</script>

<style scoped>
.buy-ticket-modal{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1055;
    display: block;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}
.numbers-positioning input{
    outline: none;
    transform: translateZ(1px);
    -webkit-transform: translateZ(1px);
    -moz-transform: translateZ(1px);
    -o-transform: translateZ(1px);
    z-index: 9999;
    color: black;
    width: 20px;
    height: 50px;
}
.winner-numbers{
    color: black;
    font-size: 30px;
    position: relative;
}
.winner-numbers img{
    width: 258px;
}
._0-winning-number{
    position: absolute;
    left: 3.5%;
    top: 6%;
    background:none;
    border: none;
    width: 20px;
}
._1-winning-number{
    position: absolute;
    left: 21%;
    top: 6%;
    width: 20px;
    background:none;
    border: none;
}
._2-winning-number{
    position: absolute;
    left: 38%;
    top: 6%;
    width: 20px;
    background:none;
    border: none;
}
._3-winning-number{
    position: absolute;
    left:55%;
    top: 6%;
    width: 20px;
    background:none;
    border: none;
}
._4-winning-number{
    position: absolute;
    left: 72%;
    top: 6%;
    width: 20px;
    background:none;
    border: none;
}
.ticket-informations{
    height: 250px;
    overflow: auto;
    direction: rtl;
    margin-left: 35px;
}
.ticket-informations::-webkit-scrollbar-track , .ticket-informations::-webkit-scrollbar-track
{
	border-radius: 10px;
	background-color: #FDDE6A;
}

.ticket-informations::-webkit-scrollbar , .ticket-informations::-webkit-scrollbar
{
	width: 11px;
}

.ticket-informations::-webkit-scrollbar-thumb , .ticket-informations::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	background-color: #C0A74A;
}
._5-winning-number{
    position: absolute;
    left: 90%;
    top: 6%;
    width: 20px;
    background:none;
    border: none;
}
.buy-ticket-header{
    background: #131b36;
    width: 100%;
    height: 129px;
    border-top-left-radius: 54px;
    border-top-right-radius: 54px;
    position: relative;
}
.confirm-and-purchase-button{
    background: none;
    border-radius: 33px;
    border: solid 4.5px #ffe371;
    color: #ffe371;
    font-size: 30px;
    padding: 0 20px;
}
.randomize-button{
    border: solid 1px #12100b;
    background-color: #131b36;
    font-size: 45px;
    color: #384e99;
    padding: 0 40px;
    margin-top: 30px;
    border-radius: 33px;
    border: solid 1px #12100b;
}
.return-button{
    border: none;
    background: none;
    font-size: 30px;
    color: white;
    margin-top: 35px;
}
.button-side-for-edit-numbers{
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 192px;
    padding-top: 35px;
    background: #131b36;
    border-bottom-left-radius: 54px;
    border-bottom-right-radius: 54px;
}
.cost-info{
    font-size: 22.5px !important;
    color: #fff;
}
.hr-line-for-cost{
    height: 3px;
    width: 100%;
    background: #384e99;
}
.max-button{
    border: none;
    background: #0a0e1c;
    border-radius: 40px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid white;
    color: white;
    font-size: 33.5px;
    width: 100%;
    margin-top: 20px;
}
.view-edit-button{
    border: none;
    background: #192447;
    border-radius: 40px;
    font-size: 25px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 69px;
    margin-top: 22px;
}
.buy-instantly-button{
    border: none;
    background: #192447;
    border-radius: 40px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    width: 100%;
    height: 69px;
    margin-top: 36px;
}
.egg-balance{
    color: white;
    font-size: 15.5px;
    text-align: right;
    width: 100%;
}
.total-ticket{
    color: white;
    font-size: 30px;
    margin-top: 35px;
    background: none;
    border: none;
    width: 80%;
    outline: none;
    text-align: right;
}
.total-price{
    color: white;
    font-size:15px;
    margin-top: -10px;
}
.calculate-background{
    width: 100%;
    height: 132px;
    background: #192447;
    border-radius: 39px;
    padding: 20px;
    text-align: right;
}
.buy-ticket-info{
    font-size: 25px;
    color: #fff;
}
.ticket-cost-info{
    font-size: 25px;
    color: #fff;
}
.buy-ticket-header span{
    font-size: 43px;
    color: #ffe371;
    margin-top: 30px;
}
.close-button{
    background: none;
    border: none;
    color: #fff;
    position: absolute;
    right: 20px;
    font-size: 41.5px;
    top: 0;
}
.inside-modal{
    top: 10%;
    width: 430px;
    height: 801px;
    margin: 20px;
    background: #0a0e1c;
    border-radius: 54px;
    border: solid 6px #ffe371;
    position: relative;
    box-shadow: 2px 2px 5pt 5pt #ead287;
}
@media (max-width:780px) {
    .buy-ticket-modal{
        top: 0;
    }
    .ticket-informations{
        margin-left: 5px;
    }
    .buy-ticket-header span{
        font-size: 25px;
    }
    .buy-ticket-header {
        height: 80px;
    }
    .cost-info{
        font-size: 15px !important;
    }
    .ticket-cost-info{
        font-size: 20px;
    }
    .buy-instantly-button{
        font-size: 20px;
        margin-top: 10px;
        height: 50px;
    }
    .randomize-button{
        margin-top: 30px;
        font-size: 30px;
    }
    .confirm-and-purchase-button{
        font-size: 20px;
        padding: 10px 15px;
    }
    .return-button{
        font-size: 20px;
    }
    .total-price , .total-ticket{
        font-size: 20px;
    }
    .max-button{
        margin-top: 5px;
        font-size: 25px;
        height: 60px;
    }
    .view-edit-button{
        font-size: 15px;
        margin-top: 10px;
        height: 50px;
    }
    .inside-modal {
        top: 10px;
        width: 90%;
        height: 90%;
    }
    @supports (-webkit-touch-callout: none) {
        .numbers-positioning input{
                width: 50px;
                margin: auto;
                -webkit-margin-start: -5px;
            }
            .winner-numbers{
                font-size: 20px;
            }
    }
    @media (max-height:700px) { 
        .inside-modal{
            height: 650px;
        }
    }
    @media (max-height:670px) {
        .inside-modal{
            height: 600px;
        }
    }
    
}
    
</style>